import BaseService from "../../../services/BaseService.ts";
import {API} from '@aws-amplify/api';
import {getApiKey} from '../../../config/amplify/api.ts';

const apiName = 'TenantManagementServiceAPI';
const collectionPath = '/users';

export const fetchRecords = (query: object) => {
    const baseService = new BaseService(apiName, collectionPath);
    return baseService.fetchRecords(query);
};

export const fetch = (id: string) => {
    const baseService = new BaseService(apiName, collectionPath);
    return baseService.fetch(id);
};

export const add = (payload: object) => {
    const baseService = new BaseService(apiName, collectionPath);
    return baseService.add(payload);
};

export const update = (id: string, payload: object) => {
    const baseService = new BaseService(apiName, collectionPath);
    return baseService.update(id, payload);
};

export const deleteRecord = (id: string) => {
    const baseService = new BaseService(apiName, collectionPath);
    return baseService.deleteRecord(id);
};

/**
 * Fetches user account configuration by location path.
 * Uses API key only (no Authorization header) so the call works
 * regardless of whether the user has an active authenticated session.
 * This avoids the 403 that occurs when an authenticated user tries
 * to read another user's record.
 */
export const fetchUserWithLocation = async (location: string) => {
    console.log(`making GET call (API key only) to ${apiName} api with path: ${location}`);

    try {
        return await API.get(apiName, location, {
            headers: {
                'x-api-key': getApiKey(),
                'Authorization': '',
            },
        });
    } catch (e: unknown) {
        console.trace('fetchUserWithLocation error:', e);
        if (typeof e === 'string') {
            throw new Error(e);
        } else if (e instanceof Error) {
            throw new Error(e.message);
        }
        throw e;
    }
};
